import { render, staticRenderFns } from "./EntityHeader.vue?vue&type=template&id=2e681f7a&scoped=true&"
import script from "./EntityHeader.vue?vue&type=script&lang=js&"
export * from "./EntityHeader.vue?vue&type=script&lang=js&"
import style0 from "./EntityHeader.vue?vue&type=style&index=0&id=2e681f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e681f7a",
  null
  
)

/* custom blocks */
import block0 from "./EntityHeader.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports